import React from "react";
import { SmartFormInterFace, SmartTable, SmartTableNewInterface } from "soft_digi";
import { SdsFsDownloadFile } from "soft_digi/dist/services/FileService";
import { SESSION_URLS } from "../../api/AdminUrls";
import { useSiteContext } from "../../contexts/SiteProvider";
import { post } from "../../services/smartApiService";
import TraineeReport from "../sessions/TraineeReport";
import PdfViewer from "../../components/PdfViewer";

interface HeaderProps {
  dataIn: any;
}
const ProjectTraineereport: React.FC<HeaderProps> = ({ dataIn }) => {
  const { openModal, closeModal, setTitle } = useSiteContext();
  const onSubmit = (dt: any) => {
    let url = SESSION_URLS.GET_TRAINEE_PDF;
    // console.log("id", _id)
    const subscription = post(url, { session_user_id: dt["ID"] }).subscribe((response) => {
      SdsFsDownloadFile(response.data.content, "Loco Pilot Report.pdf");
    });

    return () => {
      subscription.unsubscribe();
    };
  };

   const viewReportForm = (data: any) => {
    let options = {
      title: "Loco Pilot Report",
      content: <PdfViewer base64={data} />,
      className: "sd-efl-modal",
      closeBody: false,
      width: 90,
    };
    openModal(options);
  };

     const ViewReport = (dt: any) => {
      let url = SESSION_URLS.GET_TRAINEE_PDF;
      //console.log("id", dt, "url = ", url);
      const subscription = post(
        url,
        { session_user_id: dt["ID"] },
        { loadingMsg: "Loading... please Wait" }
      ).subscribe((response) => {
        // SdsFsDownloadFile(response.data.content, "Trainee Report.pdf");
        viewReportForm(response.data.content)
      });
  
      return () => {
        subscription.unsubscribe();
      };
    };

  const viewEditForm = (id: any) => {
    let options = {
      title: "Loco Pilot Report",
      content: <TraineeReport id={id} />,
      className: "sd-efl-modal",
      closeBody: false,
      width: 80,
    };
    openModal(options);
  };

  const buttons = [
    // {
    //   label: "",
    //   type: "icon",
    //   leftIcon: "fa fa-eye",
    //   classList: ["smart-hims-table-view-icon"],
    //   onClick: (data: any) => viewEditForm(data["ID"]),
    //   hideFunction: (data: any) => {
    //     return data["status"] == "completed" ? false : true;
    //   },
    // },
      {
      label: "",
      type: "icon",
      leftIcon: "fa fa-file-text",
      classList: ["has-text-primary is-size-6 is-clickable"],
      onClick: (data: any) => ViewReport(data),
      // hideFunction: (data: any) => {
      //   return data["status"] == "completed" ? false : true;
      // },
      hideFunction: (data: any) => {
        return data["status"] == "completed" ? false : true;
      },
    },
    {
      label: "",
      type: "icon",
      leftIcon: "fa fa-download",
      classList: ["smart-hims-table-edit-icon"],
      onClick: (data: any) => onSubmit(data),
      hideFunction: (data: any) => {
        return data["status"] == "completed" ? false : true;
      },
    },
  ];
  const columns: SmartTableNewInterface.SmartTableNewColumnConfig[] = [
    { title: "S.NO", index: "s_no", type: "sno", width: "5" },
    { title: "Agency Name", index: "agency_name" },
       {
      title: "Project",
      index: "project_name",
    },
    { title: "Session Id ", index: "session_label" },
 
    {
      title: "Loco Pilot Name",
      index: "ename",
    },


    {
      title: "Loco Shed",
      index: "loco_shed",
    },
    {
      title: "Time Limit",
      index: "time_limit",
      check: false,
    },
    {
      title: "Venue",
      index: "location",
    },
    {
      title: "Total Score(%)",
      index: "total_score",
    },
    // { title: "Avg score(%)", index: "pass_status"  },
    {
      title: "Status",
      index: "status",
    },
    {
      title: "Action",
      index: "action",
      type: "buttons",
      buttons: buttons,
      width: "5",
    },
  ];


  const tableTop: SmartTableNewInterface.SmartTableNewTopProps[] = [
    {
      type: "CUSTOM",
      widthClass: "is-6",
      custom: (
        <p className="is-size-4 has-text-weight-bold">Project Wise Loco Pilot Report</p>
      ),
    },

    {
      type: "BUTTONS",
      widthClass: "is-3",
      align: "CENTER",
      buttons: [
        {
          type: "EXPORT",
          className: "smart-third-button",
          // label:"",
          // icon:""
        },
        {
          type: "COLUMN-FILTER",
          label: "EX",
          className: "sd-table-export",
        },
         {
          type: "FILTER",
        },
      ],
    },
    {
      type: "SEARCH",
      widthClass: "is-3",
      align: "JUSTIFY",
    },
  ];
  const filterFields: SmartFormInterFace.SmartFormElementProps[] = [
      
          {
          type: "SELECT_BOX",
          width: "12",
          name: "project_name",
          class_name: "is-small",
          element: {
            label: "Project Name",
           size: "small",
            options: [
              { value: "WR", label: "WR" },
              { value: "NCR", label: "NCR" },
              { value: "WCR", label: "WCR" },
              { value: "SCR", label: "SCR" },
              { value: "ER", label: "ER" },
            ],
          },
        },
          
       
    
      
      ];

  return (
    <>
      <div className="sd-efl-input">
        <SmartTable
          columns={columns}
          data={dataIn}
          tableTop={tableTop}
filterFields={filterFields}
          tableProps={{
            className: "is-hoverable is-bordered smart-hims-table",
            isResponsive: true,
            searchPlaceHolder: "Search",
          }}
          allowColumnSection={true}
        // paginationProps={{
        //   pageSize: 10,
        // }}
        />
      </div>
    </>
  );
};
export default ProjectTraineereport;
